export enum jobOfferType {
  EMPLOYEE = 'employee',
  SIDEJOB = 'sideJob',
  ALLJOB = 'allJob'
}

export const pagePerItems = 6;
